import type { DataByLocation } from "../types";

const ITEM_COLOR = "#610CFF";
const MAP_AREA_COLOR = "#F3F2F5";
const MAP_BORDER_COLOR = "#B8B3C5";

const getLocationChartOptions = (
  center: [number, number],
  zoom: number,
  data: DataByLocation[],
  active: "readers" | "sessions",
  selectedCountryName?: string,
) => ({
  tooltip: {
    trigger: "item",
    backgroundColor: "#23272F",
    borderColor: "#23272F",
    borderWidth: 1,
    textStyle: {
      color: "#FFF",
      fontFamily: "Figtree",
      fontSize: 14,
      fontWeight: 500,
    },
    padding: 12,
    extraCssText:
      "max-height: 300px; overflow-y: auto; box-shadow: 0 2px 8px rgba(0,0,0,0.15); border-radius: 8px;",
    formatter: (params: any) => {
      const data = params.data;
      return `Location: ${data.city || data.country}<br/>${
        active === "readers" ? "Readers" : "Sessions"
      }: ${data.data}`;
    },
  },
  visualMap: {
    show: false,
    min: 0,
    max: 120,
    inRange: {
      symbolSize: [6, 60],
      color: [ITEM_COLOR],
    },
  },
  geo: {
    name: "World distribution",
    type: "map",
    map: "world",
    roam: "move",
    label: {
      emphasis: { show: false },
    },
    itemStyle: {
      areaColor: MAP_AREA_COLOR,
      borderColor: MAP_BORDER_COLOR,
    },
    emphasis: {
      itemStyle: {
        areaColor: "#E2D9F7", // lighter purple for hover
      },
    },
    zoom,
    center,
    scaleLimit: {
      min: 1.24,
      max: 5,
    },
    regions: selectedCountryName
      ? [
          {
            name: selectedCountryName,
            itemStyle: {
              areaColor: "#88819F",
            },
          },
        ]
      : [],
  },
  series: [
    {
      type: "scatter",
      coordinateSystem: "geo",
      data,
      symbol: "circle",
      itemStyle: {
        color: ITEM_COLOR,
        shadowBlur: 0,
        borderColor: "#FFFFFF80",
        borderWidth: 2,
      },
      emphasis: {
        itemStyle: {
          color: ITEM_COLOR,
          borderColor: "#FFFFFF80",
          borderWidth: 2,
        },
      },
    },
  ],
});
export default getLocationChartOptions;
